import { setLocale } from "react-redux-i18n";
import {
  supportedLocales,
  fallbackLocale
} from "../../assets/lang/supportedLang";
import {
  resolveLocale,
  setLocalePreference,
  getLocalePreference,
} from "../../assets/lang/localeUtils";

export function setLocaleWithFallback(desiredLocale) {
  const finalLocale = Object.keys(supportedLocales).includes(desiredLocale)
    ? desiredLocale
    : fallbackLocale;

  return dispatch => {
    setLocalePreference(finalLocale);
    dispatch(setLocale(finalLocale));
  };
}

export function setLocalePreferenceAndApply(preference) {
  return dispatch => {
    setLocalePreference(preference);
    dispatch(setLocale(resolveLocale(preference)));
  };
}

export { getLocalePreference };
